import { useEffect, useState } from "react"

/**
 * Every refetchInterval in the application goes through this. A dashboard that
 * polls while nobody is looking is rude on a metered mobile connection, and
 * NFR-DSH-18 makes pausing mandatory rather than optional.
 *
 * A literal number passed to refetchInterval is a defect.
 */
export function useVisiblePolling(intervalMs: number): number | false {
  const [visible, setVisible] = useState(() =>
    typeof document === "undefined" ? true : !document.hidden,
  )

  useEffect(() => {
    const onChange = () => {
      setVisible(!document.hidden)
    }
    document.addEventListener("visibilitychange", onChange)
    return () => {
      document.removeEventListener("visibilitychange", onChange)
    }
  }, [])

  return visible ? intervalMs : false
}
